import "./Contact.css"

function Contact(){
    return (
        <div id="contact" className="contact-container">
            <p>Samuel Yuabov</p>
            <p>Rego Park NY 11374</p>
            <p>+1 (917) 815-9106</p>
            <p>Syuabov03@outlook.com</p>
        </div>
    )
}

export default Contact;